/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/subframe/components/Badge";
import FriendInfo from "./FriendInfo";
import Templates from "./Templates";
import Message from "./Message";
import { Recipient } from "../redux/interfaces/reducersInterfaces";
import { MessagesDataWithPagination } from "../Interfaces/messagesInterface";
import TextMessageSend from "./TextMessageSend";
import { useEffect, useState } from "react";
import { IconButton } from "@/subframe/components/IconButton";

interface ChatRoomProps {
  currentRecipient: Recipient | null;
  messages: MessagesDataWithPagination;
  scrollRef: React.RefObject<HTMLDivElement>;
  // setSelectDateAndTimePopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isSwitchOn: boolean;
  onToggle: () => void;
  handleAiToHuman: () => void;
}

function ChatRoom({
  currentRecipient,
  messages,
  scrollRef,
  // setSelectDateAndTimePopupOpen,
  isSwitchOn,
  onToggle,
  handleAiToHuman,
}: ChatRoomProps) {
  const [is24HoursWindowShow, setIs24HoursWindowShow] = useState<boolean>(true);
  const [showFriendInfo, setShowFriendInfo] = useState<boolean>(() => {
    const savedState = localStorage.getItem('friendInfoVisible');
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  useEffect(() => {
    if (!currentRecipient?.recipient_last_message_time) {
      setIs24HoursWindowShow(true);
      return;
    }

    const lastMessagePassed =
      currentRecipient.recipient_last_message_time + 24 * 60 * 60 * 1000 <=
      Date.now();

    setIs24HoursWindowShow(lastMessagePassed);
  }, [currentRecipient?.recipient_last_message_time]);

  const toggleFriendInfo = () => {
    const newState = !showFriendInfo;
    setShowFriendInfo(newState);
    localStorage.setItem('friendInfoVisible', JSON.stringify(newState));
  };

  return (
    <>
      <div className="flex min-h-0 min-w-0 shrink basis-0 grow flex-col items-start self-stretch">
        <div className="flex w-full items-center justify-between border-b border-solid border-neutral-border bg-[#f1f2f6ff] px-6 py-4">
          <Badge className="hidden" variant="warning">
            Needs Human
          </Badge>
          <span className="conveythis-no-translate grow shrink-0 basis-0 text-body-bold font-body-bold text-default-font text-center">
            {currentRecipient && currentRecipient.name
              ? currentRecipient.name
              : "No name available"}
          </span>
          <IconButton
            size="small"
            icon={showFriendInfo ? "FeatherChevronRight" : "FeatherChevronLeft"}
            onClick={toggleFriendInfo}
            title={showFriendInfo ? "Hide Info" : "Show Info"}
            className="transition-transform duration-300 ease-in-out hover:scale-110"
          />
        </div>
        {/* Messages */}
        <Message
          messages={messages as any}
          scrollRef={scrollRef}
          is24HoursWindowShow={is24HoursWindowShow}
        />
        {/* <MediaMessageSend/> */}
        {/* Templates */}
        <Templates currentRecipient={currentRecipient} />

        {/* Message send */}
        {!is24HoursWindowShow && (
          <TextMessageSend
            currentRecipient={currentRecipient}
            // setSelectDateAndTimePopupOpen={setSelectDateAndTimePopupOpen}
            handleAiToHuman={handleAiToHuman}
          />
        )}
      </div>

      {/* Friend Info component */}
      <div 
        className={`flex min-h-0 flex-col self-stretch transition-all duration-300 ease-in-out ${
          showFriendInfo ? 'min-w-[280px] max-w-[384px] shrink opacity-100' : 'w-0 flex-none opacity-0'
        }`}
      >
        {showFriendInfo && (
          <FriendInfo
            currentRecipient={currentRecipient}
            messages={messages}
            isSwitchOn={isSwitchOn}
            onToggle={onToggle}
          />
        )}
      </div>
    </>
  );
}

export default ChatRoom;
